/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_HeadlineInputs */

const he_hero_headline = /** @type {(inputs: Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אף ירידת מחיר לא תחמוק לכם`)
};

const en_hero_headline = /** @type {(inputs: Hero_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never miss a price drop`)
};

/**
* | output |
* | --- |
* | "Never miss a price drop" |
*
* @param {Hero_HeadlineInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline = /** @type {((inputs?: Hero_HeadlineInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_HeadlineInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_headline(inputs)
	return en_hero_headline(inputs)
});